import { clearAuthCookie } from '@sxm-de/dev-kits/web-sdk/utils';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

export type StartAnonymousSessionFn = () => Promise<unknown>;

export function initStartAnonymousSessionFn({
    dependencies,
}: DomainInitPayload): StartAnonymousSessionFn {
    const { appEventSdk, clientSdk } = dependencies;
    return async () => {
        clearAuthCookie();
        await clientSdk.user.anonymousLogin(true);
    };
}
